import {
  AttachmentConversationMessage,
  ConversationMessageStatus,
  ConversationMessageError,
  ACCEPTED_MIME_TYPES,
  MAX_FILE_SIZE,
  Conversation,
} from '@stripe-internal/conversations-client';
import {FormattedMessage} from 'react-intl';
import prettyBytes from 'pretty-bytes';
import {view} from '@sail/ui';
import {AttachmentRow} from '../../../Chat/Row/AttachmentRow';
import {messages} from './messages';

type AttachmentMessageProps = {
  conversation: Conversation;
  message: AttachmentConversationMessage;
  avatar?: React.ReactNode | null | undefined;
  ChatRowComponent?: React.ComponentProps<
    typeof AttachmentRow
  >['ChatRowComponent'];
  ChatBubbleComponent?: React.ComponentProps<
    typeof AttachmentRow
  >['ChatBubbleComponent'];
};

export const AttachmentMessageRow = ({
  conversation,
  message,
  avatar,
  ChatRowComponent,
  ChatBubbleComponent,
}: AttachmentMessageProps) => {
  const position =
    message.participant.id === conversation.user.id ? 'end' : 'start';

  let errorMessage = null;
  if (message.status === ConversationMessageStatus.Error) {
    if (
      message.errors?.includes(ConversationMessageError.AttachmentTypeError)
    ) {
      errorMessage = (
        <FormattedMessage
          {...messages.fileTypeError}
          values={{
            mimetypes: Object.values(ACCEPTED_MIME_TYPES).join(', '),
          }}
        />
      );
    } else if (
      message.errors?.includes(ConversationMessageError.AttachmentTooLargeError)
    ) {
      errorMessage = (
        <FormattedMessage
          {...messages.fileSizeError}
          values={{maxFileSize: prettyBytes(MAX_FILE_SIZE)}}
        />
      );
    } else {
      errorMessage = <FormattedMessage {...messages.sendError} />;
    }
  }

  return (
    <view.div
      data-testid="attachment-message-row"
      data-message-type={message.participant.role}
    >
      <AttachmentRow
        name={message.attachment.name}
        size={message.attachment.size}
        avatar={avatar}
        position={position}
        error={errorMessage}
        url={message.attachment.url}
        ChatRowComponent={ChatRowComponent}
        ChatBubbleComponent={ChatBubbleComponent}
      />
    </view.div>
  );
};
